export enum RegistrationStates {
  undefined = 'undefined',
  unregistered = 'unregistered',
  registered = 'registered',
}
